module.exports = __webpack_public_path__ + "static/img/wxpay@2x.b36981ad.png";